import React from 'react';
import { GitBranch } from 'lucide-react';
import { PersistedWorkflow } from '@cotera/sdk/core';
import { Text } from '@cotera/client/app/components/ui';
import type {
  WorkflowNodeRenderStrategy,
  WorkflowNodeViewData,
} from '../types';
import { asRecord, readString } from '../../utils';

const { WorkflowNodeType } = PersistedWorkflow;

function summarize(node: WorkflowNodeViewData): string | undefined {
  const record = asRecord(node.data);
  const name = readString(record, 'name');
  if (name !== undefined && name.trim() !== '') {
    return name.trim();
  }
  const targetWorkflowId = readString(record, 'targetWorkflowId');
  if (targetWorkflowId !== undefined && targetWorkflowId.trim() !== '') {
    return 'Workflow selected';
  }
  return undefined;
}

export const runWorkflowNodeStrategy: WorkflowNodeRenderStrategy = {
  nodeType: WorkflowNodeType.RunWorkflow,
  accent: 'workflow',
  badge: 'Workflow',
  getTitle: (node) => {
    const name = readString(asRecord(node.data), 'name');
    if (name !== undefined && name.trim() !== '') {
      return name.trim();
    }
    return 'Run workflow';
  },
  getDescription: () => 'Run another workflow as a step',
  renderIcon: () => <GitBranch className="h-4 w-4" />,
  renderBody: (node) => {
    const summary = summarize(node);
    return (
      <Text.Caption className="text-muted-foreground block truncate">
        {summary ?? 'No workflow selected'}
      </Text.Caption>
    );
  },
};
